module.exports = {
  methods: {
    selectPickupDate (date, nextStep, gaEvent, gaSubType) {
      this.date = date.pickupDate;
      this.specialDateId = date.id;
      // ON SUCCESS
      this.currentStep = nextStep;

      dataLayer.push({ 
        'event': gaEvent,
        'subType': gaSubType
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/pickup/mixins/method-selectPickupDate.js